import { ToyBrickMarkerOutlineIcon } from './ToyBrickMarkerOutlineIcon';

/**
 * author: Michael Richins
 * id 6EE7FD45-3389-4007-A362-0EDB4B9DF9BD
 * name toy-brick-marker-outline
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/toy-brick-marker-outline.svg
 * tags
 * - Navigation 
 */
export const LegoOutlineIcon = ToyBrickMarkerOutlineIcon;
export default LegoOutlineIcon